/**
 * When compiling for web, it will search for index.js on root/src.
 */

import './wdyr';

import {AppRegistry} from 'react-native';
import App from './app/App';
import {name as appName} from './app.json';
import './utils/icons';

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});
